// Singletons
export const ABOUT = '/about';
export const ACCOUNT = '/account';
export const BENEFITS = '/benefits';
export const CHECKOUT = '/checkout';
export const FAQ = '/faq';
export const HOME = '/';
export const INGREDIENTS = '/ingredients';
export const LOGIN = '/account/login';
export const LONGEVITY_CLUB = '/longevityclub';
export const MITOPURE = '/mitopure';
export const NOT_FOUND = '/404';
export const LANDING_PAGES = '/pages';
export const PARTNERS = '/partners';
export const PATENTS = '/patents';
export const PODCASTS = '/podcasts';
export const PRIVACY_POLICY = '/privacy-policy';
export const PRODUCTS = '/products';
export const PROMOTIONS = '/promotions';
export const PROMOTIONS_V2 = '/promotions-v2';
export const REVIEWS = '/reviews';
export const SCIENCE = '/science';
export const SCIENCE_BODY = `${SCIENCE}/body`;
export const SCIENCE_HOW_IT_WORKS = `${SCIENCE}/how-it-works`;
export const SCIENCE_SKIN = `${SCIENCE}/skin`;
export const SHIPPING_POLICY = '/shipping-policy';
export const SHOP = '/shop';
export const STUDIES = '/studies';
export const TERMS = '/terms-and-conditions';
export const TESTIMONIALS = '/testimonials';
export const UNSUBSCRIBE_CONFIRMATION = '/unsubscribe-confirmation';

// Skincare
export const SKINCARE_PATH = '/skincare';
export const SKINCARE_HOME = SKINCARE_PATH;
export const SKINCARE_ABOUT = `${SKINCARE_PATH}${ABOUT}`;
export const SKINCARE_SHOP = `${SKINCARE_PATH}${SHOP}`;
export const SKINCARE_PRODUCTS = `${SKINCARE_PATH}${PRODUCTS}`;
export const SKINCARE_REVIEWS = `${SKINCARE_PATH}${REVIEWS}`;
export const SKINCARE_SCIENCE = `${SKINCARE_PATH}${SCIENCE}`;
export const SKINCARE_BENEFITS = `${SKINCARE_PATH}${BENEFITS}`;
export const SKINCARE_INGREDIENTS = `${SKINCARE_PATH}${INGREDIENTS}`;
export const SKINCARE_TERMS = `${SKINCARE_PATH}${TERMS}`;
export const SKINCARE_PRIVACY_POLICY = `${SKINCARE_PATH}${PRIVACY_POLICY}`;
export const SKINCARE_SHIPPING_POLICY = `${SKINCARE_PATH}${SHIPPING_POLICY}`;
export const SKINCARE_PROMOTIONS = `${SKINCARE_PATH}${PROMOTIONS}`;
export const SKINCARE_PARTNERS = `${SKINCARE_PATH}${PARTNERS}`;
export const SKINCARE_LANDING_PAGES = `${SKINCARE_PATH}${LANDING_PAGES}`;

export const siteSpecificRoutes = {
  HOME,
  ABOUT,
  SHOP,
  PRODUCTS,
  REVIEWS,
  SCIENCE,
  INGREDIENTS,
  TERMS,
  PRIVACY_POLICY,
  SHIPPING_POLICY,
  PROMOTIONS,
  PARTNERS,
};

// Collections
export const AFFILIATE_PROGRAM = '/pages/affiliate-program';

export const BLOG = '/blog';
export const BLOG_NEWS = `${BLOG}/news`;
export const BLOG_NUTRITION = `${BLOG}/nutrition`;
export const BLOG_SKINCARE = `${BLOG}/skincare`;
export const BLOG_STUDIES = `${BLOG}/studies`;

// API
export const API_CHECKOUT = '/api/checkout';
export const API_MULTIPASS = '/api/shopify/multipass';
export const API_NOTIFY_BACK_IN_STOCK = '/api/notifyBackInStock';
export const API_ONE_CLICK_CHECKOUT = '/api/shopify/oneClickCheckout';
export const API_LIST_SIGNUP = '/api/list-signup';
